function CodiceFiscale(codiceFiscale) {
    this.codiceFiscale = codiceFiscale;
    this.cfReg = /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/;
}

CodiceFiscale.prototype.isValid = function () {


    var cf = this.codiceFiscale.toUpperCase();
    if (cf == "") {
        return false;
    }

    if (!this.cfReg.test(cf)) {
        return false;
    }

    return this.validateCheckSum();
}

CodiceFiscale.prototype.validationMessage = function () {
    
    var cf = this.codiceFiscale.toUpperCase();
    if (cf == "") {
        return valMessages.userDataForm.TaxCodeRequired;
    }

    if (!this.cfReg.test(cf)) {
        return valMessages.userDataForm.TaxCode;
    }

    if (!this.validateCheckSum()) {
        return valMessages.userDataForm.TaxCode;
    }

    return "";
}

CodiceFiscale.prototype.validateCheckSum = function () {
    var cf = this.codiceFiscale.toUpperCase();
    var set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
    var s = 0;

    for (i = 1; i <= 13; i += 2) {
        s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }

    for (i = 0; i <= 14; i += 2) {
        s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }

    if (s % 26 != cf.charCodeAt(15) - 'A'.charCodeAt(0)) {
        return false;
    }

    return true;
}

